export const CAPTCHA = 'login/CAPTCHA';